import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/performance';
import 'firebase/storage';
import firebaseui from 'firebaseui';

// Firebase init
const config = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APP_ID,
};
firebase.initializeApp(config);
// const perf = firebase.performance();
firebase.performance();

// Firebase Auth
const auth = firebase.auth();
const { currentUser } = auth;
const authUi = new firebaseui.auth.AuthUI(auth);

const authValues = {
  googleAuth: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  facebookAuth: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  emailAuth: firebase.auth.EmailAuthProvider.PROVIDER_ID,
  anonymousAuth: firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
  credentialHelper: firebaseui.auth.CredentialHelper.NONE,
};

// Firestore
const db = firebase.firestore();

db.enablePersistence({ experimentalTabSynchronization: true })
  .then(() => {
    // console.log('Woohoo! Multi-Tab Persistence!');
  })
  .catch(error => {
    console.log('No offline capability', error);
  });

const dbFieldValue = firebase.firestore.FieldValue;
const timestamp = firebase.firestore.FieldValue.serverTimestamp();

const audioCollection = db.collection('audio');
const cardsCollection = db.collection('cards');
const stacksCollection = db.collection('stacks');
const stringsCollection = db.collection('strings');
const usersCollection = db.collection('users');

// Storage
const storage = firebase.storage();

// Functions
const functions = firebase.functions();

const fb = {
  db,
  auth,
  authUi,
  authValues,
  currentUser,
  dbFieldValue,
  timestamp,
  audioCollection,
  cardsCollection,
  stacksCollection,
  stringsCollection,
  usersCollection,
  storage,
  functions,
};

export default fb;
